import { gql } from '@apollo/client';

export const EVENTS_QUERY = gql`
	query Events(
		$start: DateTime
		$end: DateTime
		$types: [EventType]
		$workplaceIds: [UUID]
		$userIds: [UUID]
	) {
		events(
			start: $start
			end: $end
			types: $types
			workplaceIds: $workplaceIds
			userIds: $userIds
			pagination: { take: 9999 }
		) {
			data {
				id
				title
				dateFrom
				dateTo
				description
				type
				caseId
				description
				calendar {
					workplaceId
					workplace {
						name
						doctorDisplayName
					}
				}
				eventMembers {
					id
					userId
					user {
						id
						isPatient
						isDoctor
						formattedPhoneNumber
						profile {
							fullName
							birthNumber
							age
						}
					}
					status
					role
				}
				layout
				meta {
					key
					value
				}
			}
		}
	}
`;

export const EVENT = gql`
	query Event($id: UUID) {
		event(id: $id) {
			id
			title
			dateFrom
			dateTo
			description
			type
			caseId
			description
			eventMembers {
				id
				userId
				user {
					isPatient
					isDoctor
					profile {
						fullName
					}
				}
				status
				role
			}
			layout
		}
	}
`;
